import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';
import Img1 from 'assets/Home/portfolio/chainex1.avif'

const ChainEx = ({ data }: any) => {
    return (
        <>
            <section className='pb-24 tablet:pb-8 container'>
                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-2xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Website Details
                </motion.h4>

                <motion.img
                    src={Img1}
                    alt="Img1"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                >
                </motion.img>
            </section>
        </>
    )
}

export default ChainEx
